export default "__VITE_ASSET__jm8KMjcd__"